<template>
  <div style="height: 100%;">
    <!--    整一个页面 -->
    <el-container style="height: 100%;">
      <!--      左边侧边栏 -->
      <!--      这是一个框 -->
      <el-aside :width="sideWidth + 'px'">
        <!--        这是左侧边栏内容-->
        <Aside :isCollapse="isCollapse" :logoTextShow="logoTextShow"></Aside>
      </el-aside>

      <!--    右边数据栏  -->
      <el-container>
        <!--  整个数据栏的：border-bottom: 1px solid #ccc : 底部边框为 1像素的实线，颜色为灰色（#ccc）-->
        <el-header style="border-bottom: 1px solid #ccc;">
          <!-- 数据栏-头部组件 -->
          <Header :collapseBtnClass="collapseBtnClass" :collapse="collapse" :user="user"></Header>
        </el-header>
        <!--       数据主体 -->
        <el-main style="width: 100%; ">
          <!-- router view 用来展示子路由 -->
          <router-view></router-view>
        </el-main>

      </el-container>
    </el-container>


  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Aside from "@/components/Aside";
import Header from "@/components/Header";
import request from "@/util/request";

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    Aside,
    Header
  },
  mounted() {

  },
  data() {
    return {
      sideWidth: 200,
      collapseBtnClass: 'el-icon-s-fold',
      // 左侧边栏默认展开false or收起true
      isCollapse: false,
      logoTextShow: true,
      // 浏览器获取
      // 数据存在就将浏览器中的存储数据的字符串转为 JSON
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
    }
  },
  methods: {
    // 点击收缩按钮触发
    collapse() {
      // this.isCollapse = !this.isCollapse;
      // this.logoTextShow = !this.logoTextShow;
      // if (!this.isCollapse) {
      //   this.sideWidth = 200
      // }else{
      //   this.sideWidth = 50
      // }
    },

  }
}
</script>

<style>
.headerBg {
  background: whitesmoke !important;
}



</style>
